// cSpell: ignore putaoid, Unmount

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import $ from 'jquery';

import utils from '../../lib/utils';
import { putaoWS } from '../../lib/ws';
import request from '../../lib/request';
import PathTitle from '../../lib/components/LessonPath/path-title';
import { LevelGuideBackground, BrownRow, Mask } from '../../lib/components/LessonPath/static/style';
import LessonLevels from '../../lib/components/LessonPath/lesson-levels';
import Back from '../../lib/components/LessonPath/back';
import { COURSE_TYPE, Node } from '../../lib/components/LessonPath/static/json/constant';
import MedalDialog from '../../lib/components/LessonPath/medal-dialog';

import DownloadDialog from '../../components/lesson-path/download-dialog';
import { LessonsBackGround, LessonNodeBackGround } from '../../components/lesson-path/path-background';
import Lessons from '../../components/lesson-path/lesson-box';
import LessonNode from '../../components/lesson-path/lesson-node';
import AllCourse from '../../components/lesson-path/all-course';
import ChooseLevel from '../../components/dialog/ChooseLevel';
import BuyCourse from '../../components/dialog/BuyCourse';
import GiftPicture from '../../components/lesson-path/gift-picture';
import { DialogContent, DialogText, DialogButton } from '../../components/dialog/static/style';
import TrailCountDown from '../../components/dialog/TrailCountDown';

import { reqAPI } from '../../server/reqAPI';
import { abnormalReporting, getUserInfo, getNeedShowChooseLevel, specialCourse } from '../../server/commonFun';
import '../../static/css/common.scss';
// import '../static/css/lesson-path.scss';

export default class LessonPath extends React.Component {
    static childContextTypes = {
        clickCardHandler: PropTypes.func,
    };

    getChildContext() {
        const that = this;
        return {
            clickCardHandler: that.clickCardHandler,
        };
    }

    constructor(props, context) {
        super(props);

        this.state = {
            lessonData: null,
            lessonNodeData: null,
            showLevel: false,
            showAllCourse: false,
            coursePosition: utils.getQueryString("special") ? { level: utils.getQueryString("special"), unit: 1 } : { level: 1, unit: 1 },
            userInfo: null,
            showBuyCourse: false,    // 显示购买弹窗
            showChooseLevel: false,  // 显示选择级别弹窗
            showTrailTips: false,  // 体验课不一致弹窗
            trailCid: null, //体验课的 cid
            trailTips: '',     // 体验课不一致的提示信息
            showTrailCountDown: false,  // 体验课倒计时弹窗
            showGiftPic: false, // 显示礼物碎片
            giftPicUrl: '', // 礼物碎片的地址
            showDownloadButton: false, // 是否显示下载按钮
            showDownloadDialog: false, // 是否显示下载弹窗
            clickDownloadFlag: false, //是否直接点击下载
        };

        this.clickCardHandler = this.clickCardHandler.bind(this);
        this.clickNodeHandler = this.clickNodeHandler.bind(this);
        this.hashChangeHandler = this.hashChangeHandler.bind(this);
        this.hasInit = false;// 记录是否是第一次（只有第一次需要获取当前的状态）
        this.code = parseInt(utils.getQueryString("code"), 10);
        this.special = utils.getQueryString("special");
    }

    componentDidMount() {
        const that = this;
        this.hashChangeHandler();
        that.canSocketTimer = null;

        // this.clickLevelGuideHandler();

        // 添加事件
        window.addEventListener('hashchange', this.hashChangeHandler);
    }

    componentWillUnmount() {
        // 移除事件
        window.removeEventListener('hashchange', this.hashChangeHandler);
        // 去掉所有的提示信息
        utils.showTips('', 1);
        // 清除只有在该组件中有效的数据
        window.localStorage.removeItem(`${this.context.user.putaoid}_position${this.special || ""}`);
        window.localStorage.removeItem('activeCid');
        clearTimeout(this.canSocketTimer);
    }

    // hash 改变处理函数
    hashChangeHandler() {
        const cid = utils.getQueryString('cid');
        this.special = utils.getQueryString("special");

        this.setState({
            cid
        }, () => {
            this.getInitData();
        });
    }

    // 点击返回处理事件
    clickBackHandler() {
        const { showAllCourse, showLevel, cid } = this.state;
        if (showAllCourse || showLevel) {
            this.setState({
                showAllCourse: false,
                showLevel: false
            });
        } else if (cid) {
            let isSpecial = specialCourse(cid);
            window.location.href = `#/path${isSpecial ? "?special=" + isSpecial : ""}`;
        } else {
            // window.history.back();
            window.location.href = '#/';
        }
    }

    getInitData() {
        const that = this;
        const { cid, lessonData } = this.state;

        if (cid) {
            this.getCourseNode();
        } else {
            this.locateLessonHandler(lessonData && lessonData.cid ? lessonData.cid : '');

            if (!this.hasInit) {
                // 只有第一次进来的时候需要获取当前的位置
                getUserInfo(this.context.user).then((res) => {
                    // 定位到上一次点击的 level 和 unit，或者是用户当前应该上的位置
                    let position = window.localStorage.getItem(`${that.context.user.putaoid}_position${that.special || ""}`);
                    if (position && position !== "null") {
                        position = JSON.parse(position);
                    } else if (that.special) {
                        position = { level: that.special, unit: 1 };
                    } else {
                        position = (res && res.course_position ? res.course_position : null);
                    }
                    that.setState({ userInfo: res });
                    that.hasInit = true;
                    that.changeCurrentCourseHandler(position);

                    // 判断是否应该出选择级别
                    if (res && res.residueCourseNum) {
                        getNeedShowChooseLevel(that.context.user).then(res => {
                            if (res.code && res.code === 200 && res.data && res.data.residueCourseNum) {
                                that.setState({ showChooseLevel: true, levelInfo: res.data })
                            }
                        });
                    }
                });
            }
        }
    }

    // 获取当前 unit 的所有课程
    getUnitCourse() {
        const that = this;
        const { coursePosition } = this.state;

        utils.showCommonLoading();
        return new Promise((resolve, reject) => {
            request(reqAPI.unit_lesson, Object.assign({}, that.context.user, { level: coursePosition.level, unit: coursePosition.unit }), { method: 'GET' })
                .then(res => res.json())
                .then(res => {
                    utils.hideCommonLoading();
                    if (res.code && res.code === 200) {
                        that.setState({
                            lessonData: res.data,
                            lessonNodeData: null
                        }, () => {
                            // 定位到当前应该学习的位置（数据是请求回来的）-- 为了解决切换 unit 时，滑动过程中会有 hover 效果，从而滚动到选中卡片的bug 
                            // 加了只有需要定位到当前课程时的限制
                            if (res.data && res.data.cid && document.querySelector(`#card_${res.data.cid}`)) {
                                that.locateLessonHandler(res.data.cid);
                            }
                            resolve();
                        });
                    } else {
                        abnormalReporting({
                            putaoid: this.context.user.putaoid,
                            url: reqAPI.unit_lesson,
                            type: 'data',
                            res
                        });
                    }
                })
                .catch(err => {
                    utils.hideCommonLoading();
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.unit_lesson,
                        type: 'request',
                        err
                    });
                });
        });
    }

    // 获取当前 unit 的名称与 level、unit 信息等
    getUnitName() {
        const { coursePosition } = this.state;

        request(reqAPI.unit_name, { level: coursePosition && coursePosition.level, unit: coursePosition && coursePosition.unit, putaoid: this.context.user.putaoid }, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.code && res.code === 200) {
                    this.setState({
                        unitNameData: res.data
                    });
                } else {
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.unit_name,
                        type: 'data',
                        res
                    });
                }
            });
    }

    // 获取课程步骤
    getCourseNode() {
        const that = this;
        const { cid } = this.state;

        utils.showCommonLoading();
        request(reqAPI.lesson_node, Object.assign({}, this.context.user, { cid: cid }), { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                utils.hideCommonLoading();
                if (res.code && res.code === 200) {
                    this.setState({
                        lessonNodeData: res.data
                    });

                    // 有学习权限——判断是否需要显示下载按钮
                    if (res.data.lessonNode && !res.data.lessonNode.nodeLesson.lessonLocked) {
                        putaoWS.getCidDownloadProgress(cid, (data) => {
                            let progress = data.progress || 0;
                            // 下载完不显示弹窗
                            that.setState({
                                progress,
                                showDownloadButton: progress < 100 ? true : false
                            });
                        });
                    }
                } else {
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.lesson_node,
                        type: 'data',
                        res
                    });
                }
            })
            .catch(err => {
                utils.hideCommonLoading();
                abnormalReporting({
                    putaoid: this.context.user.putaoid,
                    url: reqAPI.lesson_node,
                    type: 'request',
                    err
                });
            });
    }

    // 点击切换 unit
    clickToggleUnitHandler(direction) {
        const that = this;
        const { coursePosition, unitNameData } = this.state;

        let tempCoursePosition = coursePosition;

        if (direction > 0) {
            if (tempCoursePosition.unit >= unitNameData.unitNum) {
                tempCoursePosition.level += 1;
                tempCoursePosition.unit = 1;
            } else {
                tempCoursePosition.unit += 1;
            }

            // 点击下一单元只需要当前这个单元的单元数就好
            that.changeCurrentCourseHandler(tempCoursePosition);
        } else if (direction < 0) {
            if (tempCoursePosition.unit > 1) {
                tempCoursePosition.unit -= 1;
                // 点击上一单元，不修改 level 时，只需要当前这个单元的单元数就好
                that.changeCurrentCourseHandler(tempCoursePosition);
            } else if (tempCoursePosition.level > 0 && !that.special) {
                tempCoursePosition.level -= 1;
                // 点击上一单元，修改 level 时，需要上一个单元的单元数
                request(reqAPI.unit_name, { level: tempCoursePosition.level, unit: 1, putaoid: this.context.user.putaoid }, { method: 'GET' })
                    .then(res => res.json())
                    .then(res => {
                        if (res.code && res.code === 200 && res.data) {
                            tempCoursePosition.unit = res.data.unitNum;
                            that.changeCurrentCourseHandler(tempCoursePosition);
                        }
                    });
            }
        }
    }

    // 点击卡片处理函数
    // 剩余课时为0——显示购买弹窗
    // 需要选择级别——选择级别弹窗
    clickCardHandler(data) {
        const that = this;
        const { userInfo } = this.state;

        if (userInfo && !userInfo.remaining && data.nodeType && data.nodeType !== COURSE_TYPE.trialLesson && data.nodeType !== COURSE_TYPE.video && userInfo.isCourseEx) {
            this.setState({ showBuyCourse: true });
            return;
        }

        if (userInfo && userInfo.residueCourseNum) {
            getNeedShowChooseLevel(that.context.user).then(res => {
                if (res.code && res.code === 200 && res.data && res.data.residueCourseNum) {
                    that.setState({ showChooseLevel: true, levelInfo: res.data })
                } else {
                    that.linkCourseNodeHandler(data);
                }
            });
        } else {
            this.linkCourseNodeHandler(data);
        }
    }

    // 跳转到课程步骤( cid 是直接跳转)
    linkCourseNodeHandler(data, cid) {
        if (cid) {
            window.location.href += `${window.location.hash.indexOf('?') > -1 ? '&' : '?'}cid=${cid}`;
        } else if (data && data.nodeDetails && data.nodeDetails.lessonCid) {
            // 如果是体验课，判断 lessonAppointmentCid 与 lessonCid 是否一致，如果不一致，显示弹窗，提示去学习
            if (data.nodeType && data.nodeType === COURSE_TYPE.trialLesson && data.nodeDetails.lessonAppointmentCid &&
                data.nodeDetails.lessonAppointmentCid !== data.nodeDetails.lessonCid) {
                this.setState({
                    showTrailTips: true,
                    trailCid: data.nodeDetails.lessonAppointmentCid,
                    trailTips: data.nodeDetails.lessonMsg
                });
            } else if (data.nodeDetails.lessonLock && data.nodeDetails.lessonMsg) {
                utils.showTips(data.nodeDetails.lessonMsg, 2000);
            } else {
                window.location.href += `${window.location.hash.indexOf('?') > -1 ? '&' : '?'}cid=${data.nodeDetails.lessonCid}`;
            }
        } else if (data && data.nodeDetails && data.nodeDetails.examURL) {
            if (!data.nodeDetails.examLock) {
                window.location.href = data.nodeDetails.examURL;
            } else {
                utils.showTips(data.nodeDetails.examMsg, 2000);
            }
        }
    }

    // 点击 level 的小路标，点击展开所有 level
    clickLevelGuideHandler = () => {
        const { coursePosition } = this.state;

        request(reqAPI.lesson_level, Object.assign({}, this.context.user, { level: coursePosition.level ? coursePosition.level : 1 }), { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.code && res.code === 200) {
                    this.setState({
                        showLevel: true,
                        levels: res.data && res.data.levels ? res.data.levels : null
                    });
                } else {
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.lesson_level,
                        type: 'data',
                        res
                    });
                }
            })
            .catch(err => {
                abnormalReporting({
                    putaoid: this.context.user.putaoid,
                    url: reqAPI.lesson_level,
                    type: 'request',
                    err
                });
            });
    }

    // 展开 level 后，点击选择 level
    clickLevelCardHandler(level, ) {
        const that = this;

        // if (level < 1) {
        //     return;
        // }

        const tempCoursePosition = {
            level: level,
            unit: 1
        }

        if (utils.showCommonLoading) {
            utils.showCommonLoading();
        }

        this.changeCurrentCourseHandler(tempCoursePosition, () => {
            that.setState({ showLevel: false });
        });
    }

    // 点击课程节点的处理函数(flag 是 直接学习的标志函数)
    clickNodeHandler(locked, msg, url, type, value, flag) {
        const that = this;
        const { cid } = that.state;

        if (locked) {
            utils.showTips(msg ? msg : '学完前面的内容才能开始哦', 1500);
        } else if (type === Node.lesson) {
            if (flag || !window.canSocket) {
                this.goLessonHandler(value);
            } else {
                if (window.canSocket) {
                    that.canSocketTimerExecFlag = false;
                    // 如果是在客户端中，需要判断当前的进度是否小于 50，是的话需要显示下载弹窗，大于等于 50 ——去学习
                    putaoWS.getCidDownloadProgress(cid, (data) => {
                        clearTimeout(that.canSocketTimer);
                        if (that.canSocketTimerExecFlag) {
                            return;
                        }
                        let progress = data.progress || 0;
                        if (progress < 50) {
                            this.setState({
                                progress,
                                showDownloadDialog: true
                            });
                        } else {
                            that.goLessonHandler(value);
                        }
                    });

                    that.canSocketTimer = setTimeout(() => { // 防止客户端太久没有回调，导致页面卡死
                        that.canSocketTimerExecFlag = true;
                        that.goLessonHandler(value);
                    }, 500);
                }
            }
        } else if (type === Node.summary || type === Node.homework) {
            const tempUrl = `${url}&putaoid=${this.context.user.putaoid}&token=${encodeURIComponent(this.context.user.token)}&from=${this.context.user.from}`;

            // 如果是阅读课的练一练，需要新页面打开，防止在绘本馆的时候因为返回按钮，造成死循环
            if (value && value.nodeType && value.nodeType === COURSE_TYPE.readingLesson && type === Node.homework) {
                window.open(tempUrl);
            } else {
                window.location.href = tempUrl;
            }
        } else if (type === Node.gift) {

            this.setState({
                showGiftPic: true,
                giftPicUrl: url,
            });

        } else {
            window.location.href = url;
        }
    }

    // 跳转去学习
    goLessonHandler(value) {
        const that = this;
        const { cid, lessonNodeData } = this.state;
        const testPageNumber = window.localStorage.getItem('testAreaInputNumber');

        if (value.lessonSystime && value.lessonStartTime && value.lessonStartTime > value.lessonSystime) {
            this.setState({ showTrailCountDown: true });
        } else {
            // window.location.href = `#/on?cid=${cid}`;
            window.location.href = `${window.publicUrl}?v=${window.pt_vid}${that.code === 2 ? "&code=2" : ""}#/on?cid=${cid}${testPageNumber ? '&page=' + parseInt(testPageNumber, 10) : ''}${lessonNodeData && lessonNodeData.lessonNode && lessonNodeData.lessonNode.nodeHomework && lessonNodeData.lessonNode.nodeHomework.homeworkURL ?
                '&homeworkurl=' + encodeURIComponent(lessonNodeData.lessonNode.nodeHomework.homeworkURL)
                : ''
                }`;
            //改成跳转新的url，情况前面页面的内存
        }
    }

    // 在全部课程页面切换 unit
    allCourseChangeUnitHandler(unit, lesson) {
        if (!unit || typeof unit !== 'number') {
            return;
        }

        const that = this;

        const tempCoursePosition = {
            level: this.state.coursePosition.level,
            unit: unit
        };

        this.changeCurrentCourseHandler(tempCoursePosition, () => {
            that.setState({ showAllCourse: false });
            that.locateLessonHandler(lesson);
        });
    }

    // 点击标题上的小三角，打开全部课程
    clickAllCourseHandler() {
        this.setState({ showAllCourse: true });
    }

    // 改变当前的 level 和 unit 
    changeCurrentCourseHandler(position, callback) {
        const that = this;
        let tempPosition = position;

        if (tempPosition && tempPosition.unit && tempPosition.unit >= 100) {
            tempPosition.unit = 1;
        }

        that.setState({
            coursePosition: position
        }, () => {
            $('#lessons-list-box').animate({ scrollLeft: 0 });
            that.getUnitCourse().then(() => callback && typeof callback === 'function' ? callback() : null);
            that.getUnitName();
        });
        window.localStorage.setItem(`${this.context.user.putaoid}_position${that.special || ""}`, JSON.stringify(position));
    }

    // 定位到固定课程
    locateLessonHandler(position, e) {
        let time = 500;

        setTimeout(function () {
            var tempElement = document.querySelector(`#card_${position}`);

            // 如果没有固定的定位位置，例如当前应该学习的位置。则定位到上一次选中的位置
            if (!tempElement && window.localStorage.getItem('activeCid')) {
                tempElement = document.querySelector(`#card_${window.localStorage.getItem('activeCid')}`);
            }

            if (tempElement) {
                var bodyWidth = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
                $('#lessons-list-box').animate({
                    scrollLeft: tempElement.offsetLeft - bodyWidth / 2 + tempElement.clientWidth / 2, // 使它定位到最中间;
                }, time);
            }
        }, 300);
    }

    closeBuyCourseHandler() {
        this.setState({ showBuyCourse: false });
    }

    // 级别选择成功
    handleChooseLevelSuccess() {
        const that = this;

        getUserInfo(this.context.user).then((res) => {
            that.setState({
                userInfo: res,
                showChooseLevel: false
            });
            that.changeCurrentCourseHandler(res && res.course_position ? res.course_position : null);
        });
    }

    handleChooseLevelClose() {
        this.setState({ showChooseLevel: false });
    }

    clickCloseGiftHandler(e) {
        this.setState({ showGiftPic: false });
    }

    clickGiftHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        const { cid } = this.state;

        window.location.href = `#/my-gift?cid=${cid}`;
    }

    clickCloseTrailCountDownHandler() {
        this.setState({ showTrailCountDown: false });
    }

    // 点击下载
    clickDownloadHandler = () => {
        this.setState({
            showDownloadDialog: true,
            clickDownloadFlag: true,
        });
    }

    // 隐藏下载弹窗
    hideDownloadDialog() {
        this.setState({
            showDownloadDialog: false,
            clickDownloadFlag: false
        });
    }

    // 隐藏下载按钮
    hideDownloadButton() {
        this.setState({
            showDownloadButton: false,
            clickDownloadFlag: false
        });
    }

    render() {
        const { showLevel, showAllCourse, levels, lessonData, unitNameData, lessonNodeData, showTrailCountDown,
            cid, coursePosition, levelInfo, showChooseLevel, showBuyCourse, showGiftPic, giftPicUrl, showTrailTips, trailTips, trailCid,
            showDownloadDialog, showDownloadButton, clickDownloadFlag
        } = this.state;
        let level = unitNameData && unitNameData.level;
        let showLevelStr = "";
        if (this.special) {
            // showLevelStr = 'KET真题讲解';
            showLevelStr = `Unit ${unitNameData && unitNameData.unit ? unitNameData.unit : ''}`
        } else {
            showLevelStr = `level ${level || 'k'}-unit ${unitNameData && unitNameData.unit ? unitNameData.unit : ''}`;
        }

        return (
            <Path>
                <Back onClick={this.clickBackHandler.bind(this)} />
                {(showLevel || showAllCourse) ?
                    <LessonNodeBackGround>
                        {/* 选择 level */}
                        {showLevel && <LessonLevels
                            data={levels}
                            special={this.special}
                            active={coursePosition.level}
                            clickLevelCardHandler={this.clickLevelCardHandler.bind(this)}
                        />}
                        {/* 当前 level 的所有课程 */}
                        {showAllCourse &&
                            <AllCourse
                                level={coursePosition.level}
                                allCourseChangeUnitHandler={this.allCourseChangeUnitHandler.bind(this)}
                            />}
                    </LessonNodeBackGround>
                    : (!cid ?
                        <LessonsBackGround type='lesson'>
                            {/* 课程路径 */}
                            <PathTitle
                                level={showLevelStr}
                                title={unitNameData && unitNameData.unitName && level !== 2004 ? unitNameData.unitName : ''}
                                onClick={this.clickAllCourseHandler.bind(this)}
                            />
                            <LevelGuide onClick={this.clickLevelGuideHandler}>
                                <div>
                                    {this.special ?
                                        `Module ${unitNameData && unitNameData.level ? unitNameData.level - 2003 : ''}`
                                        : ` level ${unitNameData && unitNameData.level ? unitNameData.level : 'k'}`
                                    }
                                </div>
                                <Row />
                            </LevelGuide>
                            {lessonData && unitNameData &&
                                <Lessons
                                    lessonData={lessonData}
                                    unitInfo={unitNameData}
                                    clickToggleUnitHandler={this.clickToggleUnitHandler.bind(this)}
                                />}
                        </LessonsBackGround>
                        :
                        <LessonNodeBackGround type='lesson'>
                            {/* 课程步骤 */}
                            <PathTitle type='simple' title={lessonNodeData && lessonNodeData.lessonTitle ? lessonNodeData.lessonTitle : ''} />
                            {lessonNodeData &&
                                <LessonNode
                                    data={lessonNodeData}
                                    onClick={this.clickNodeHandler}
                                />}
                            {/* 获取勋章弹窗 */}
                            <MedalDialog />
                            {showDownloadButton && lessonNodeData &&
                                <Download
                                    onClick={this.clickDownloadHandler}
                                />
                            }
                            {showDownloadDialog &&
                                <DownloadDialog
                                    hideDownloadDialog={this.hideDownloadDialog.bind(this)}
                                    hideDownloadButton={this.hideDownloadButton.bind(this)}
                                    clickDownloadFlag={clickDownloadFlag}
                                    clickStartLessonHandler={
                                        () => this.clickNodeHandler(
                                            lessonNodeData.lessonNode.nodeLesson.lessonLocked,
                                            lessonNodeData.lessonNode.nodeLesson.lessonMsg,
                                            lessonNodeData.lessonNode.nodeLesson.lessonUrl,
                                            Node.lesson,
                                            lessonNodeData.lessonNode,
                                            true
                                        )}
                                />}
                        </LessonNodeBackGround>
                    )
                }
                {showBuyCourse && <BuyCourse level={coursePosition.level} closeBuyCourseHandler={this.closeBuyCourseHandler.bind(this)} />}
                {showChooseLevel && levelInfo &&
                    <ChooseLevel
                        data={levelInfo}
                        successChooseLevelHandler={this.handleChooseLevelSuccess.bind(this)}
                        clickCloseHandler={this.handleChooseLevelClose.bind(this)}
                    />
                }
                {showTrailCountDown &&
                    <TrailCountDown
                        cid={cid}
                        data={lessonNodeData.lessonNode.nodeLesson}
                        level={lessonNodeData.level ? lessonNodeData.level : coursePosition.level}
                        clickCloseTrailCountDown={this.clickCloseTrailCountDownHandler.bind(this)}
                    />
                }
                {showTrailTips &&
                    <Mask onClick={() => { this.setState({ showTrailTips: false }) }}>
                        <DialogContent>
                            <DialogText>{trailTips}</DialogText>
                            <DialogButton onClick={(e) => { e.preventDefault(); this.linkCourseNodeHandler(null, trailCid) }}>去学习</DialogButton>
                        </DialogContent>
                    </Mask>
                }
                {showGiftPic && giftPicUrl && <GiftPicture
                    cid={cid}
                    src={giftPicUrl}
                    onClick={this.clickCloseGiftHandler.bind(this)}
                    clickGiftHandler={e => this.clickGiftHandler(e)}
                />}
            </Path>
        );
    }
}

// 定义子组件需要使用的属性
LessonPath.contextTypes = {
    user: PropTypes.object,
    userInfo: PropTypes.object,
    getUser: PropTypes.func,
};

const Path = styled.div`
    width: 100%;
    height: 100%;
`;

const LevelGuide = styled(LevelGuideBackground)`
    position: fixed;
    top: 0;
    right: 19.3%;
    padding: 0.56rem 0 0 0.26rem;
    cursor: pointer;
    span {
        opacity: 0.5;
    }
    &:hover {
        span {
            opacity: 1;
        }
    }
`;

const Row = styled(BrownRow)`
    position: absolute;
    top: 0.66rem;
    right: 0.2rem;
`;

const Download = styled.div`
    position: fixed;
    bottom: 0.31rem;
    right: 0.92rem;
    width: 1.07rem;
    height: 0.92rem;
    background: url(${require('../../components/lesson-path/img/icon-download.png')}) no-repeat center;
    background-size: contain;
    z-index: 999;
`;



// WEBPACK FOOTER //
// ./src/route/version-2/LessonPath.js